<template>
  <div class="proHl reveal px-10vw">
    <ul>
        <li v-for="item in items" :key="item.title">
            <div class="img">
              <img :src="item.img" v-if="item.img.length>0" :title="item.title" />

              <iframe v-if="item.video.length>0"
                src="https://player.vimeo.com/video/1033482433" 
                style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" 
                frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="">
              </iframe>

            </div>            
            <h5>{{item.title}}</h5>
            <p>{{item.summary}}</p>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        items:[
            {
              video:"",
              img:"img/_temp/lynx_nextgen.png",
              title:"MIS LYNX: NextGen Simplicity",
              summary:"MIS LYNX is an all-in-one implant system that takes Simplicity to new heights. With single-use drills included with every implant, the MIS CLEAR™ wet surface, and a broad prosthetic range, MIS LYNX offers clinicians a reliable and valuable choice."
            },
            {
              video:"https://vimeo.com/1033482433",
              img:"",
              title:"How To",
              summary:"MIS LYNX is an all-in-one implant system that takes Simplicity to new heights. With single-use drills included with every implant, the MIS CLEAR™ wet surface, and a broad prosthetic range, MIS LYNX offers clinicians a reliable and valuable choice."
            }
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),

    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
  }
};
</script>

<style scoped>

    .proHl
    {
        width: 100%;
        min-height: 200px;
        color: #202020;
        padding: 2vw 5vw 5vw 5vw;
    }
    .proHl .psTitle
    {
        color: #202020;
        width: 100%;
    }
    .proHl ul
    {
        padding-top: 40px;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
    }
    .proHl ul li
    {
        text-align:left;
        background:transparent; /* keep minimalist; add border or bg if desired */
    }
    .proHl ul li .img
    {
        background: #202020;
        height: 26vw;
        width: 100%;
        position: relative;
    }

    .proHl ul li img
    {
        height: 100%;
        width: 100%;
        object-fit: fill;
    }
    .proHl ul li h5
    {
        padding-top: clamp(15px,2vw,50px);
        font-size: 24px;
        color: #202020;
        width: 70% !important;
        font-weight: 300 !important;
    }
    .proHl ul li p
    {
        width: 70%;
        padding-top: 20px;
        font-size: 16px;
        color: #202020;
    }

    @media (hover: hover) {
    }

    @media screen and (max-width: 815px)
    {
        .proHl
        {
            padding: 5vw 5vw;
        }
        .proHl ul
        {
            grid-template-columns: 1fr;
        }
        .proHl ul li h5,
        .proHl ul li p
        {
          width: 100%;
        }
        .proHl ul li .img
        {
            height: 55vw;
            width: 100%;
            position: relative;
        }        
    }


    @media only screen and (min-width:2000px)
    {
    }
</style>
